import SuppliersSelectedModal from '@/components/_common/SuppliersSelectedModal';
import VehiclesSelectedModal from '@/components/_common/VehiclesSelectedModal';
import { CustomerVehicleReduced } from '@/core/domain/people/CustomerVehicles/CustomerVehicles.types';
import { Supplier } from '@/core/domain/people/Suppliers/Suppliers.types';
import { QuestQuotationReportFormValues } from '@/core/domain/questReport/Reports/Quotation/Quotation.types';
import { useDisclosure } from '@/hooks';
import { Badge, Button, Col, Collapse, Form, Row } from 'antd';
import { FormInstance } from 'antd/es/form/Form';
import { useState } from 'react';
import { useIntl } from 'react-intl';

interface Props {
  form: FormInstance<QuestQuotationReportFormValues>;
}

const QuotationReportMoreOptions: React.FC<Props> = ({ form }) => {
  const { Panel } = Collapse;
  const intl = useIntl();

  const [supplierVisible, setSupplierVisible] = useDisclosure();
  const [supplierId, setSupplierId] = useState<number[]>();

  const [openVehicle, setOpenVehicle] = useDisclosure();
  const [selectedVehicles, setSelectedVehicles] =
    useState<CustomerVehicleReduced[]>();

  return (
    <Collapse accordion>
      <Panel
        header={intl.formatMessage({
          id: 'quotation.moreOptions',
        })}
        key={1}
      >
        <Row gutter={[24, 24]}>
          <Col span={24} md={12} lg={6} xxl={4}>
            <Badge count={supplierId?.length}>
              <Button type="primary" onClick={setSupplierVisible.open}>
                {intl.formatMessage({
                  id: 'quotation.moreOptions.button.selectSupplier',
                })}
              </Button>
            </Badge>
          </Col>

          <Col span={24} md={12} lg={6} xxl={4}>
            <Badge count={selectedVehicles?.length}>
              <Button type="primary" onClick={setOpenVehicle.open}>
                {intl.formatMessage({
                  id: 'quotation.moreOptions.button.selectVehicle',
                })}
              </Button>
            </Badge>
          </Col>
        </Row>
        <Form.Item name="supplierIds" hidden />
        <Form.Item name="vehicleIds" hidden />
      </Panel>

      <SuppliersSelectedModal
        handleVisible={setSupplierVisible.close}
        visible={supplierVisible}
        finishCallback={(suppliers) => {
          setSupplierId(suppliers);
          form.setFieldValue('supplierIds', suppliers);
        }}
        selectedSuppliers={
          supplierId?.map((cur) => ({ id: cur })) as unknown as Supplier[]
        }
      />

      <VehiclesSelectedModal
        handleVisible={setOpenVehicle.close}
        visible={openVehicle}
        selectedVehicle={selectedVehicles}
        finishCallback={(vehicle) => {
          setSelectedVehicles(vehicle);
          form.setFieldValue(
            'vehicleIds',
            vehicle?.map(({ id }) => id),
          );
        }}
      />
    </Collapse>
  );
};

export default QuotationReportMoreOptions;
